var _style, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 550.795 550.795",
    style: {
      enableBackground: "new 0 0 113.4 113.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style869"
  }, "\r\n        .st0{fill:#717070}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.613 491.782c12.381 0 23.109-4.088 32.229-12.16L377.793 323.567a2878.213 2878.213 0 0 0-10.801 7.767c-11.678 8.604-21.156 15.318-28.434 20.129-7.277 4.822-16.959 9.737-29.045 14.755-12.094 5.024-23.361 7.528-33.813 7.528h-.612c-10.453 0-21.72-2.503-33.813-7.528-12.093-5.018-21.775-9.933-29.045-14.755-7.277-4.811-16.75-11.524-28.434-20.129a1351.934 1351.934 0 0 0-10.771-7.809L16.946 479.622c9.119 8.072 19.854 12.16 32.234 12.16h452.433z",
    id: "path871"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.047 225.299C19.37 217.514 9.015 208.598 0 198.555V435.98l137.541-137.541c-27.516-19.21-62.969-43.562-106.494-73.14z",
    id: "path873"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M520.059 225.299c-41.865 28.336-77.447 52.73-106.75 73.195l137.486 137.492V198.555c-8.815 9.841-19.059 18.751-30.736 26.744z",
    id: "path875"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M501.613 59.013H49.181c-15.784 0-27.919 5.33-36.42 15.979C4.253 85.646.006 98.97.006 114.949c0 12.907 5.636 26.892 16.903 41.959 11.267 15.061 23.256 26.891 35.961 35.496 6.965 4.921 27.969 19.523 63.012 43.801a20367.497 20367.497 0 0 1 49.505 34.395 8855.122 8855.122 0 0 1 31.022 21.701c.985.691 2.534 1.799 4.59 3.269 2.215 1.591 5.018 3.61 8.476 6.107 6.659 4.816 12.191 8.709 16.597 11.683 4.4 2.975 9.731 6.298 15.985 9.988 6.249 3.685 12.143 6.456 17.675 8.299 5.533 1.842 10.655 2.766 15.367 2.766h.612c4.711 0 9.834-.924 15.368-2.766 5.531-1.843 11.42-4.608 17.674-8.299 6.248-3.69 11.572-7.02 15.986-9.988 4.406-2.974 9.938-6.866 16.598-11.683 3.451-2.497 6.254-4.517 8.469-6.102a643.575 643.575 0 0 1 4.596-3.274c6.684-4.651 17.1-11.892 31.104-21.616 25.482-17.705 63.01-43.764 112.742-78.281 14.957-10.447 27.453-23.054 37.496-37.803 10.025-14.749 15.051-30.22 15.051-46.408 0-13.525-4.873-25.098-14.598-34.737-9.736-9.627-21.265-14.443-34.584-14.443z",
    id: "path877"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717070",
      fillOpacity: 1,
      strokeWidth: 0.56900311
    },
    d: "M269.707 333.726c-13.761-1.772-28.774-9.985-63.443-34.71-18.124-12.926-47.386-33.355-106.688-74.485-57.682-40.005-55.83-38.63-66.29-49.2-17.959-18.146-29.058-36.007-32.178-51.782-.905-4.58-.758-15.989.283-21.925C3.107 91.84 7.074 82.823 12.91 75.443c5.461-6.907 12.401-11.575 21.328-14.346l4.17-1.295 234.713-.157c215.203-.143 235.069-.08 238.982.771 17.992 3.911 33.598 19.548 37.359 37.435 1.11 5.285 1.064 16.798-.096 23.404-1.826 10.398-6.735 22.309-13.233 32.104-7.932 11.955-19.7 24.672-30.905 33.393-3.26 2.537-38.318 27.098-77.907 54.579-39.588 27.48-78.572 54.683-86.631 60.449-30.787 22.028-46.212 30.213-60.254 31.974-5.214.654-5.436.653-10.728-.028z",
    id: "path886"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717070",
      fillOpacity: 1,
      strokeWidth: 0.56900311
    },
    d: "M0 317.285V199.228l5.832 5.738c11.315 11.132 13.044 12.417 57.327 42.61 41.173 28.073 73.402 50.4 73.402 50.85 0 .198-30.726 31.085-68.28 68.638L0 435.342Z",
    id: "path888"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717070",
      fillOpacity: 1,
      strokeWidth: 0.56900311
    },
    d: "M39.261 490.53c-4.442-.91-7.3-1.91-11.42-3.993-3.556-1.799-9.377-5.65-9.957-6.59-.507-.82 154.55-155.95 155.51-155.584.387.147 6.78 4.683 14.21 10.08 26.459 19.223 35.86 24.812 53.938 32.07 19.946 8.006 35.648 9.417 53.486 4.805 7.347-1.9 11.186-3.309 21.695-7.964 14.429-6.392 22.185-11.227 47.516-29.62 6.944-5.042 12.904-9.273 13.245-9.403.34-.13 35.57 34.732 78.287 77.47l77.67 77.704-2.277 1.96c-3.047 2.623-11.01 6.706-16.238 8.326l-4.246 1.316-233.86.09c-192.786.075-234.51-.042-237.559-.667Z",
    id: "path890"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#717070",
      fillOpacity: 1,
      strokeWidth: 0.56900311
    },
    d: "M482.244 366.793c-41.878-41.88-68.05-68.46-67.71-68.766 1.32-1.188 57.458-39.744 90.456-62.126 24.427-16.568 28.721-19.885 39.688-30.663l6.117-6.01v117.916c0 64.853-.064 117.916-.143 117.916-.079 0-30.862-30.72-68.408-68.267z",
    id: "path892"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f6ac27b16a0bf619150d7cf36cd719f7.svg";
export { ForwardRef as ReactComponent };